export default {
  text: 'De kaart wordt geleverd door Google. Bij het laden wordt je IP-adres naar Google gestuurd.',
  buttons: {
    show_map: 'Kaart tonen',
    retry: 'Probeer het opnieuw',
  },
  errors: {
    map_unavailable: 'De kaart kon niet worden geladen.',
  },
};
